import { CurrentClassesQuery, UpdateClassMutation } from "src/api/Class";
import { withApi, withApiMutation } from "src/stores/Api";

export const UpdateClass = withApiMutation(UpdateClassMutation, {
  name: "updateClass",
});

export const QueryCurrentClasses = withApi(CurrentClassesQuery, {
  name: "queryCurrentClasses",
  skip: ({ match }: any) => {
    const activeKey =
      match.params && match.params.tab ? match.params.tab : "active";
    return activeKey === "archived" || activeKey === "all";
  },
  options: ({ store }: any) => {
    return {
      variables: {
        organizationId: store.organization.id,
      },
    };
  },
});
